/* eslint-disable @typescript-eslint/no-unused-expressions */
import { RAMError } from './RAMError';
import packageJson from './../../package.json';
import moment from 'moment';
import NodeTypeEnum from '../components/Hierarchy/types/nodeType';

export const isNull = val => val === typeof null;
export const isEmptyObject = obj =>
  Object.keys(obj).length === 0 && obj.constructor === Object;
export const isEmptyString = str => !str || isNull(str);
export const isValidZipCode = str => /^\d{5}$/.test(str);
export const isValidNumber = str => /^\d{0,}$/.test(str);
export const isValidUSAZipCode = str => /^\d{5}(-\d{4})?$/.test(str);
export const isValidCanadaZipCode = str => /^.{6}$/.test(str);
export const maxMinLength = str => /.{1,80}/.test(str);
export const maxLength = str => str.length <= 80;
export const isValidPhoneNumber = str => /^[0-9]{1,80}$/.test(str);
export const isValidExtensionNumber = str => {
  return str === '' || /^\d{1,80}$/.test(str);
};
export const isValidEmail = str =>
  /^\w+([.-]?\w?)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(str);
export const isUndefined = val => typeof val === 'undefined';
export const isNumber = val => typeof val === 'number';
/**
 * Takes an object and convert it in to url Format.
 * @deprecated use instead Axios object parameters object
 * @returns {string} objet parsed to url params format
 * @param searchObj
 */
export const constructSearchObj = (searchObj: any) => {
  let searchString = '';
  for (const [key, value] of Object.entries<any>(searchObj)) {
    if (isNumber(value) || value) {
      const val = encodeURIComponent(value);
      if (searchString) {
        searchString += `&${key}=${val}`;
      } else {
        searchString += `?${key}=${val}`;
      }
    }
  }
  return searchString;
};
/**
 * Array of default times value used for
 * @type {string[]}
 */
export const arrivalTimes = [
  '',
  '00:00',
  '00:30',
  '01:00',
  '01:30',
  '02:00',
  '02:30',
  '03:00',
  '03:30',
  '04:00',
  '04:30',
  '05:00',
  '05:30',
  '06:00',
  '06:30',
  '07:00',
  '07:30',
  '08:00',
  '08:30',
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
  '12:00',
  '12:30',
  '13:00',
  '13:30',
  '14:00',
  '14:30',
  '15:00',
  '15:30',
  '16:00',
  '16:30',
  '17:00',
  '17:30',
  '18:00',
  '18:30',
  '19:00',
  '19:30',
  '20:00',
  '20:30',
  '21:00',
  '21:30',
  '22:00',
  '22:30',
  '23:00',
  '23:30',
  '',
];
export const times = [
  '',
  '00:00',
  '00:30',
  '01:00',
  '01:30',
  '02:00',
  '02:30',
  '03:00',
  '03:30',
  '04:00',
  '04:30',
  '05:00',
  '05:30',
  '06:00',
  '06:30',
  '07:00',
  '07:30',
  '08:00',
  '08:30',
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
  '12:00',
  '12:30',
  '13:00',
  '13:30',
  '14:00',
  '14:30',
  '15:00',
  '15:30',
  '16:00',
  '16:30',
  '17:00',
  '17:30',
  '18:00',
  '18:30',
  '19:00',
  '19:30',
  '20:00',
  '20:30',
  '21:00',
  '21:30',
  '22:00',
  '22:30',
  '23:00',
  '23:30',
  '23:59',
  '',
];
/**
 * Used to mainly to convert a simple sentence in to a object key with snake_case_format
 * almost translations with dynamic value should use it.
 * @param str
 */
export const textToSnakeCase = (str = '') => {
  if (str) {
    return str
      .toLowerCase()
      .trim()
      .replace(/[\s+|-]/g, '_');
  }
  return '';
};
/**
 * @param perms The param is the array of perms taken from okta.
 * @description  convert an array of permissions into a global object used to bring access to determinate sections on the app.
 * @return {Object} All the permissions to enable or disable a view are contained on this object.
 */
export const auth = (perms = ['']) => {
  const apptype = perms[0].substring(0, 3) === 'RAM' ? 'RAM' : 'FRUM';
  const map = {
    apptype,
    hasBrandSwitching: false,
    hasViewRestaurant: false,
    hasSearchRestaurant: false,
    hasEditRestaurant: false,
    hasViewHoursOfOperation: false,
    hasEditHoursOfOperation: false,
    hasCreateManufacturer: false,
    hasEditManufacturer: false,
    hasCreateEquipment: false,
    hasViewEquipment: false,
    hasSearchEquipment: false,
    hasEditEquipment: false,
    hasEditSpecificEquipmentFields: false,
    hasCalibrationProfileEquipment: false,
    hasHoldingProfileEquipment: false,
    hasAssignEquipment: false,
    hasViewMenuItemListAndDetails: false,
    hasViewMenuItemDetails: false,
    hasViewMenuItemList: false,
    hasSearchMenuItem: false,
    hasHoldingProfileMenuItem: false,
    hasAssignMenuItems: false,
    hasViewCommodities: false,
    hasSearchCommodities: false,
    hasHoldingProfileCommodities: false,
    hasDisplayMultiLanguage: false,
    hasCreateTranslationsMultilanguage: false,
    hasMenuItemsLearningPlans: false,
    hasEquipmentLearningPlans: false,
    hasCommoditiesLearningPlans: false,
    hasRestaurantLearningPlans: false,
    hasViewMenuItemOperationHours: false
  };
  const permsarray =
    apptype === 'RAM'
      ? perms.map(e => e.substring(8, 11))
      : perms
        .filter(p => p.substring(2, 5) === 'RAM')
        .map(e => e.substring(6, e.length));
  const purePerms = [...new Set(permsarray)];
  if (apptype === 'RAM') {
    const isHelpDeskUser = perms.filter(e => e.substring(4, 7) === 'GHD').length;
    isHelpDeskUser ? purePerms.push('GHD') : null;
  }
  map.hasBrandSwitching = includesArray(purePerms, ['BSW', 'BRAND_SW']);
  map.hasViewRestaurant = includesArray(purePerms, ['RVW', 'REST_VIEW']);
  map.hasSearchRestaurant = includesArray(purePerms, ['RSR', 'REST_SEARCH']);
  map.hasEditRestaurant = includesArray(purePerms, ['RED', 'REST_EDIT', 'RVW']);
  map.hasViewHoursOfOperation = includesArray(purePerms, [
    'RHV',
    'REST_VIEW_OP_HOURS',
  ]);
  map.hasEditHoursOfOperation = includesArray(purePerms, [
    'RHE',
    'REST_EDIT_OP_HOURS',
  ]);

  //PBI #10846 - Commenting below 4 lines of code just to disable mass upload for now and enable it in future, as this will be moving to production in disabled mode only.

  map.hasViewMenuItemOperationHours = includesArray(purePerms, [
    'GHD',
    'MENU_OP_HOURS_EDIT',
  ]);
  map.hasCreateManufacturer = includesArray(purePerms, [
    'EMC',
    'EQUIP_CREATE_MANUF',
  ]);
  map.hasEditManufacturer = includesArray(purePerms, [
    'EME',
    'EQUIP_EDIT_MANUF',
  ]);
  map.hasCreateEquipment = includesArray(purePerms, ['EEC', 'EQUIP_CREATE']);
  map.hasViewEquipment = includesArray(purePerms, ['EEV', 'EQUIP_VIEW']);
  map.hasSearchEquipment = includesArray(purePerms, ['EES', 'EQUIP_SEARCH']);
  map.hasEditEquipment = includesArray(purePerms, ['EEE', 'EQUIP_EDIT']);
  map.hasEditSpecificEquipmentFields = purePerms.includes(
    'EQUIP_EDIT_SPEC_FIELDS',
  );
  map.hasCalibrationProfileEquipment = purePerms.includes('EEP');
  map.hasHoldingProfileEquipment = includesArray(purePerms, [
    'EEH',
    'EQUIP_EDIT',
  ]);
  map.hasAssignEquipment = includesArray(purePerms, ['EEA', 'EQUIP_ASSIGN']);
  map.hasViewMenuItemListAndDetails = includesArray(purePerms, ['MVW']);
  map.hasViewMenuItemList = includesArray(purePerms, ['MENU_ITEM_VIEW']);
  map.hasViewMenuItemDetails = includesArray(purePerms, ['MENU_ITEM_DETAILS']);
  map.hasSearchMenuItem = includesArray(purePerms, ['MSR', 'MENU_ITEM_SEARCH']);
  map.hasAssignMenuItems = includesArray(purePerms, [
    'MAR',
    'MENU_ITEM_ASSIGN',
  ]);
  map.hasHoldingProfileMenuItem = purePerms.includes('MHP');
  map.hasViewCommodities = purePerms.includes('CVW');
  map.hasSearchCommodities = purePerms.includes('CSR');
  map.hasHoldingProfileCommodities = purePerms.includes('CHP');
  map.hasDisplayMultiLanguage = purePerms.includes('UCD');
  map.hasCreateTranslationsMultilanguage = purePerms.includes('UCT');
  map.hasMenuItemsLearningPlans = purePerms.includes('LMI');
  map.hasEquipmentLearningPlans = purePerms.includes('LEQ');
  map.hasCommoditiesLearningPlans = purePerms.includes('LCM');
  map.hasRestaurantLearningPlans = includesArray(purePerms, [
    'RLP',
    'LEARNINGPLANS_EDIT',
  ]);

  return { ...map };
};

/**
 *
 * @param arrayToSearch
 * @param stringsToFind
 *
 * @return Boolean
 * @description Search elements on array if exist in another.
 */
export function includesArray(
  arrayToSearch: unknown[],
  stringsToFind: any[] = [],
) {
  return !!stringsToFind
    .map(stringsToFind => arrayToSearch.includes(stringsToFind))
    .filter(e => e).length;
}

export function nanToZero(number) {
  return isNaN(number) ? 0 : number;
}

export function nanToGreater(number) {
  return isNaN(number) ? 25000 : number;
}

export function sortProfilesByLocation(profiles) {
  const regions: any[] = [];
  const countries: any[] = [];
  const states: any[] = [];

  profiles.forEach(profile => {
    if (
      !profile.country_id &&
      !profile.state_id &&
      !regions.some(r => r.region === profile.region)
    ) {
      regions.push(profile);
    } else if (
      !profile.state_id &&
      profile.country_id &&
      !countries.some(c => c.country_id === profile.country_id)
    ) {
      if (!profile.country.name) {
        profile.country.name = profile.country.description;
      }
      countries.push(profile);
    } else if (
      profile.state_id &&
      !states.some(s => s.state_id === profile.state_id)
    ) {
      if (!profile.state.name) {
        profile.state.name = profile.state.description;
      }
      states.push(profile);
    }
  });

  regions.sort((regionA, regionB) => {
    if (regionA.region === 'GLOBAL') {
      return -1;
    }
    if (regionB.region === 'GLOBAL') {
      return 1;
    }
    return regionA.region > regionB.region
      ? 1
      : regionA.region < regionB.region
        ? -1
        : 0;
  });
  countries.sort((A, B) =>
    A.country.name > B.country.name
      ? 1
      : A.country.name < B.country.name
        ? -1
        : 0,
  );
  states.sort((A, B) =>
    A.state.name > B.state.name ? 1 : A.state.name < B.state.name ? -1 : 0,
  );

  return [...regions, ...countries, ...states];
}

/**
 *
 * @param response
 * @constructor
 * @description Check response status to throw an error in case of 400 and eval if it comes with an translatable error code
 */
export function EvalResponse(response) {
  const statusGroup = Number((response.status / 100).toFixed(0));
  if (statusGroup !== 2) {
    if (statusGroup === 4) {
      const messages = response.data?.error_description || [
        'Unexpected error occurred',
      ];
      throw new RAMError(response.data?.error_code, messages);
    } else if (response.data.error_code) {
      throw new RAMError(response.data?.error_code, [`INTERNAL_ERROR_SERVER`]);
    }
    throw new Error(response.data?.error_description);
  }
}

export const browserHardRefresh = () => {
  const version = localStorage.getItem('version');
  const versionCacheDateString = localStorage.getItem('version-cache-date');

  const today = moment();
  const versionCacheDate = versionCacheDateString ? moment(versionCacheDateString, 'YYYY-MM-DD HH:mm:ss') : today;
  const versionCacheDateWeeksLater = versionCacheDate.add(2, 'weeks');

  if (version !== packageJson.version || today.isAfter(versionCacheDateWeeksLater)) {
    if ('caches' in window) {
      caches.keys().then((names) => {
        // Delete all the cache files
        names.forEach(name => {
          caches.delete(name);
        })
      });
    }

    localStorage.clear();
    localStorage.setItem('version', packageJson.version);
    localStorage.setItem('version-cache-date', today.format('YYYY-MM-DD HH:mm:ss'));

    // Makes sure the page reloads. Changes are only visible after you refresh.
    window.location.reload();
  }
};

export const formatYYYYMMDD = 'YYYY-MM-DD';

export const showHolidayToolTip = (event) => {
  let rect = event.target.getBoundingClientRect();
  const verticalOffset = 50;
  const horizontalOffset = 40;
  let x = rect.left;
  let y = rect.top + window.scrollY;
  const div = document.createElement('div');
  div.classList.add('tooltip-holiday')
  div.innerHTML = event.target.getAttribute('data-type-holiday-event');;
  document.body.appendChild(div);
  div.style.top = `${y - verticalOffset}px`;
  div.style.left = `${x - horizontalOffset}px`;

}

export const removeHolidayToolTip = () => {
  const div = document.querySelectorAll('.tooltip-holiday');
  div[0] && div.forEach(e => {
    e.remove()
  });
}

export const removeEventListenersForToolTip = () => {
  const dateSelected: any = document.querySelectorAll(
    `[data-type-holiday-event]`,
  );
  if (dateSelected[0]) {
    dateSelected.forEach(el => {
      el.removeEventListener('mouseenter', showHolidayToolTip);
      el.removeEventListener('mouseleave', removeHolidayToolTip);
    })
  }
}

export const createHolidayEvent = (date: string, dateSelected: HTMLLIElement, eventName: string) => {
  if (dateSelected) {
    let holidayEvent = dateSelected.getAttribute('data-type-holiday-event');
    if (holidayEvent && !holidayEvent.includes(eventName)) {
      holidayEvent += `, ${eventName}`;
      dateSelected.setAttribute('data-type-holiday-event', holidayEvent);
    }
    else if (!dateSelected.querySelector('data-type-holiday')) {
      const div = document.createElement('div');
      div.setAttribute('data-type-holiday', 'Holiday');
      const span = document.createElement('span');
      span.innerHTML = moment(date).date().toString();
      div.appendChild(span);
      dateSelected.setAttribute('data-type-holiday-event', eventName)
      dateSelected.addEventListener('mouseenter', showHolidayToolTip)
      dateSelected.addEventListener('mouseleave', removeHolidayToolTip)
      dateSelected.appendChild(div);
    }
  }
}
export const getCommonRestraunts = (equipmentSelected) => {
  let set = new Set<number>();
  let commonElements = new Array<number>();
  for (const [index, item] of equipmentSelected.entries()) {
    const { equipment_restaurants } = item;
    if (!equipment_restaurants) break;
    let flag = false;
    for (let equipment_restaurant of equipment_restaurants) {
      const { restaurant_id } = equipment_restaurant
      if (set.has(restaurant_id)) {
        flag = true
        commonElements.push(restaurant_id);
      }
      else set.add(restaurant_id);
    }

    if (index > 0) {
      set = new Set([...commonElements])
      commonElements = [];
      if (!flag) break;
    }


  }
  return Array.from(set);
}

export const getAllRestaurants = (children): any[] => {
  let res: any[] = [];
  for (let child of children) {
    if (child.type === NodeTypeEnum.REPORTING_GROUP && child.hasChildren) {
      res = [...res, ...getAllRestaurants(child.children)]
    } else if (child.type === NodeTypeEnum.RESTAURANT) {
      res = [...res, child];
    }
  }
  return res;
}

export const isChildrenSelected = (selectedRestaurants: string[] = [], children: any[] = [], type: NodeTypeEnum.REPORTING_UNIT | NodeTypeEnum.REPORTING_GROUP): boolean => {
  if (type === NodeTypeEnum.REPORTING_UNIT) {
    let flattenedRestaurants = getAllRestaurants(children);
    return selectedRestaurants.length === flattenedRestaurants.length;
  } else if (type === NodeTypeEnum.REPORTING_GROUP) {
    let res = true;
    for (let child of children) {
      if (child.type === NodeTypeEnum.RESTAURANT && !selectedRestaurants.includes(child.text)) return false
      else if (child.type === NodeTypeEnum.REPORTING_GROUP) res = res && isChildrenSelected(selectedRestaurants, child.children, child.type)
    }
    return res;
  }
  return false;

}

export const downloadFileFromURL = (url: string, fileName: string) => {
  if (!url) return;
  let anchor = document.createElement('a');
  anchor.download = fileName
  anchor.href = url;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}

export const uploadFileOnS3 = async (url: string, file: any) => {
  await fetch(url, {
    method: "PUT",
    body: file,
  });
};
